import React from 'react'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'

import './styles.scss'

const NotResult = ({ className, message }) => {
  return (
    <div className={`containerMessageNotResult ${className ? className : ''}`}>
      <img className='iconEmpty' src={getStaticImage('/icons/orange-brand/icon-empty.svg')} alt='icon-empty' />
      <p className='textMessageNotResult'>{lang(message || 'not_result_apply_filter')}</p>
    </div>
  )
}

export default NotResult